import React, { Component } from "react";
import { Button, Tabs } from "antd";
import "./Table.css";
import ReactDataGrid from "react-data-grid";
import Excel from "exceljs";
import FileSaver from "file-saver";
import Spinner from "./../Spinner";
import filters from "./../../core/filters";
import AuthRender from "../../../../containers/AuthRender";
import { ACCESS, SERVICES } from "../../../../configs/constants";

const formats = {
  BOOLEAN: "Boolean",
  RADIO: "radio",
  CHECKBOX: "checkbox",
  equals: (s1 = "", s2 = "") => {
    if (s1 === null || s2 === null) return false;
    return s1.toLowerCase() === s2.toLowerCase();
  }
};
const { TabPane } = Tabs;
class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uiLoading: true
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        uiLoading: false
      });
    }, 100);
  }
  hasData(data) {
    return Array.isArray(data) && data.length >= 2;
  }

  /**
   * Get column configs by kpi
   * @param kpi
   * @param data
   * @return {*[]|Array}
   */
  getColumnsConfigsByKpi(kpi = {}, data) {
    return this.getStandardColumnsConfigs(data);

    if (kpi.format === "text" || [9, 26, 3, 29, 282, 437, 461].indexOf(kpi.id) !== -1) {
      return this.getStandardColumnsConfigs(data);
    }

    return this.getSizedColumnsConfigs(data);
  }

  /**
   * get columns (table format)
   * @param data
   * @return {Array}
   */
  getSizedColumnsConfigs(data = []) {
    const columns = [];
    if (data.length < 1) return columns;
    const columnsRow = data[0];
    const widths = {
      0: 70,
      1: 200,
      4: 50
    };
    for (let i = 0; i < columnsRow.length; i++) {
      const datum = columnsRow[i];
      columns.push({
        id: i,
        name: datum,
        key: i,
        editable: false,
        resizable: true,
        width: widths[i],
        frozen: i < 6,
        height: 300
      });
    }

    return columns;
  }

  /**
   * Get visit columns configs
   * @param data
   * @return {[]}
   */
  getStandardColumnsConfigs(data) {
    const columns = [];
    if (data.length < 1) return columns;
    const columnsRow = data[0];
    for (let i = 0; i < columnsRow.length; i++) {
      const datum = columnsRow[i];
      columns.push({
        id: i,
        name: datum,
        key: i,
        editable: false,
        resizable: true,
        //width: widths[i],
        frozen: false,
        height: 300
      });
    }

    return columns;
  }
  /**
   * get rows (table format)
   * @param data
   * @return {Array}
   */
  getRows(data = []) {
    const rows = [];
    if (data.length < 1) rows;
    for (let i = 1; i < data.length; i++) {
      const line = data[i] || [];
      const row = {};
      for (let j = 0; j < line.length; j++) {
        const lineElement = line[j];
        row[j] = lineElement;
      }
      rows.push(row);
    }
    return rows;
  }

  /**
   * get columns (xlsx format)
   * @param data
   * @return {Array}
   */
  getColumnsXLSX(data = []) {
    const widths = {
      0: 8
    };

    const columns = [];
    if (data.length < 1) columns;
    const columnsRow = data[0];
    for (let i = 0; i < columnsRow.length; i++) {
      const datum = columnsRow[i] || "";
      columns.push({
        key: i,
        header: datum,
        width: widths[i] || 20
      });
    }

    return columns;
  }

  /**
   * Get rows (xlsx format)
   * @param data
   * @return {Array}
   */
  getRowsXLSX(data = []) {
    const rows = [];
    if (data.length < 1) rows;
    for (let i = 1; i < data.length; i++) {
      const line = data[i] || [];
      const row = [];
      for (let j = 0; j < line.length; j++) {
        const lineElement = line[j];
        row.push(lineElement);
      }
      rows.push(row);
    }

    return rows;
  }

  addFiltersToXLSX(worksheet) {
    const values = filters.getValues(this.props.filters, this.props.period);
    const valuesKeys = Object.keys(values);
    values["period"] = values["period"] || {};
    worksheet.addRow([`Période du ${values["period"].start || ""} au ${values["period"].end || ""}`]);

    delete values["period"];
    for (let i = 0; i < valuesKeys.length; i++) {
      const valuesKey = valuesKeys[i];
      const valueElts = values[valuesKey] || [];

      for (let j = 0; j < valueElts.length; j++) {
        //add header
        if (j === 0) {
          worksheet.addRow([valuesKey]);
          worksheet.getRow(worksheet.rowCount).font = { bold: true };
        }
        const valueElt = valueElts[j];
        //add value
        worksheet.addRow([valueElt]);

        //add footer
        if (j === valueElts.length - 1) {
          worksheet.addRow([""]);
        }
      }
    }
  }
  /**
   * Export data to xlsx
   */
  export(data, title = "") {
    const { kpi = {} } = this.props;

    if (!this.hasData(data)) return;
    //get data

    const columns = this.getColumnsXLSX(data);
    const rows = this.getRowsXLSX(data);

    if (formats.equals(kpi.format, formats.RADIO)) {
      const donneesIndex = columns.findIndex(col => col.header === "Données");
      const kpiValues = Array.isArray(kpi.values) ? kpi.values : [];
      rows.map(row => (row[donneesIndex] = kpiValues[row[donneesIndex]]));
    }

    let workbook = new Excel.Workbook();
    workbook.creator = "EFFICIENCE SELL";
    workbook.created = new Date();

    let worksheet = workbook.addWorksheet("Données", {
      views: [{ xSplit: 4, ySplit: 1 }]
    });
    worksheet.columns = columns;
    worksheet.addRows(rows);

    //add style
    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).alignment = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true
    };
    worksheet.alignment = { vertical: "middle", horizontal: "center" };

    //add filters information
    let worksheetFilter = workbook.addWorksheet("Filtres");
    worksheetFilter.columns = [
      {
        key: 0,
        header: "Filtres"
      }
    ];
    worksheetFilter.getRow(1).font = { bold: true };
    this.addFiltersToXLSX(worksheetFilter);
    let filename = kpi.short_label || "";
    if (title) filename += ` (${title})`;

    //worksheetFilter.addRows();
    workbook.xlsx
      .writeBuffer()
      .then(buffer => FileSaver.saveAs(new Blob([buffer]), `${filename}.xlsx`))
      .catch(err => console.log("Error writing excel export", err));
  }

  /**
   * TODO
   * @return {*}
   */
  renderEmpty() {
    return <div />;
  }

  renderData(data, title) {
    const { kpi = {} } = this.props;
    const columns = this.getColumnsConfigsByKpi(kpi, data); //this.getColumns(data);
    let rows = this.getRows(data);
    if (formats.equals(kpi.format, formats.RADIO)) {
      const donneesIndex = columns.findIndex(col => col.name === "Données");
      const kpiValues = Array.isArray(kpi.values) ? kpi.values : [];
      rows = rows.map(row => ({ ...row, [donneesIndex]: kpiValues[row[donneesIndex]] }));
    }
    return (
      <div
        style={{
          position: "relative",
          alignItems: "center",
          justifyContent: "center",
          paddingTop: 15,
          overflow: "hidden"
        }}
      >
        <ReactDataGrid
          columns={columns}
          rowGetter={i => rows[i]}
          rowsCount={rows.length}
          minHeight={400}
          minColumnWidth={100}
          enableCellSelect={false}
          enableCellAutoFocus={false}
          enableDragAndDrop={false}
          headerRowHeight={100}
          rowSelection={{
            enableShiftSelect: true,
            showCheckbox: false
          }}
        />
        <AuthRender service={SERVICES.Statistiques} access={ACCESS.export}>
          <Button
            style={{ marginTop: 5, float: "right" }}
            type="primary"
            size={"default"}
            onClick={() => {
              return this.export(data, title);
            }}
          >
            Exporter
          </Button>
        </AuthRender>
      </div>
    );
  }

  renderContent(data, title) {
    if (this.state.uiLoading) return null;
    if (!Array.isArray(data) || data.length < 2) return this.renderEmpty();

    return this.renderData(data, title);
  }
  renderTabs(tabs) {
    return (
      <Tabs defaultActiveKey="0">
        {tabs.map((tab, i) => {
          return (
            <TabPane tab={tab.title} key={i}>
              {this.renderContent(tab.data, tab.title)}
            </TabPane>
          );
        })}
      </Tabs>
    );
  }
  render() {
    const { data = {} } = this.props;
    const tabs = [];

    if (Array.isArray(data)) {
      tabs.push(this.renderContent(data));
    } else {
      const type = data.type;
      const dataTabs = data.tabs || [];
      tabs.push(this.renderTabs(dataTabs));
      /*
			for (let i = 0; i < dataTabs.length; i++) {
				const sheet = dataTabs[i] || {};
				const title = sheet.title || "";
				const sheetData = sheet.data || [];
				tabs.push(this.renderContent(sheetData, title))
			}*/
    }
    return (
      <div style={{ minHeight: 450, position: "relative" }}>
        {tabs}
        <Spinner
          tip={"Veuillez patienter, le temps de chargement peut prendre plusieurs secondes"}
          spinning={this.props.tableLoading || this.state.uiLoading}
        />
      </div>
    );
  }
}

export default Table;



// WEBPACK FOOTER //
// src/modules/stats/components/Table/Table.js